import type { CatalogResponse } from '@nadoutong/contracts';
import { platformApiRequest } from './client.ts';

export type ConsoleCatalogBrand = 'nadoutong' | 'nxtpath';

export async function getCatalogForBrand(
  fetchImpl: typeof fetch,
  brand: ConsoleCatalogBrand,
  signal?: AbortSignal,
): Promise<CatalogResponse> {
  const params = new URLSearchParams({ brand });
  return platformApiRequest<CatalogResponse>(
    `/v1/catalog/me?${params.toString()}`,
    { signal },
    fetchImpl,
  );
}
